import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ClassEnrollment } from './class-enrollment';
export { ClassEnrollment };
import { classEnrollmentSchema } from '@schemas/business-objects/class-enrollment';
import { CandidateFormGroup } from './candidate-form-group';
import { TrainingClassFormGroup } from './training-class-form-group';

export class ClassEnrollmentFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    status: SchemaFormControl;
    candidateId: SchemaFormControl;
    candidate: CandidateFormGroup;
    trainingClassId: SchemaFormControl;
    trainingClass: TrainingClassFormGroup;
  };

  declare value: Partial<ClassEnrollment>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(classEnrollmentSchema, ClassEnrollment, data, options);
  }

  get object(): ClassEnrollment {
    return new ClassEnrollment(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'candidate':
        return new CandidateFormGroup();
      case 'trainingClass':
        return new TrainingClassFormGroup();
      default:
        return undefined;
    }
  }
}

export class ClassEnrollmentFormArray extends PersistedFormArray {
  readonly entityName = 'ClassEnrollment' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(classEnrollmentSchema, ClassEnrollment, options);
  }

  protected override createItemGroup() {
    return new ClassEnrollmentFormGroup();
  }

  get array(): ClassEnrollment[] {
    return this.controls.map((group: ClassEnrollmentFormGroup) => group.object);
  }
}

export class ClassEnrollmentPersistedArray extends PersistedArray<ClassEnrollment> {
  readonly entityName = 'ClassEnrollment' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ClassEnrollment, options);
  }
}
